export default "__VITE_ASSET__Dwqdm1Y0__"